module.exports = __webpack_public_path__ + "static/media/pdfIcon.00ff45e9.svg";